<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect width="16" height="16" fill="transparent"/>
<path d="M-4607 -2063C-4607 -2064.1 -4606.1 -2065 -4605 -2065H2874C2875.1 -2065 2876 -2064.1 2876 -2063V8261C2876 8262.1 2875.1 8263 2874 8263H-4605C-4606.1 8263 -4607 8262.1 -4607 8261V-2063Z" fill=""/>
<g clip-path="url(#clip0_3388_33495)">
<rect width="428" height="3145" transform="translate(-114 -1062)" fill=""/>
<g clip-path="url(#clip1_3388_33495)">
<rect x="-84" y="-118" width="174" height="189" rx="20" fill=""/>
<path d="M-84 -1H90V51C90 62.0457 81.0457 71 70 71H-64C-75.0457 71 -84 62.0457 -84 51V-1Z" fill="#"/>
</g>
</g>
<path d="M-4605 -2064H2874V-2066H-4605V-2064ZM2875 -2063V8261H2877V-2063H2875ZM2874 8262H-4605V8264H2874V8262ZM-4606 8261V-2063H-4608V8261H-4606ZM-4605 8262C-4605.55 8262 -4606 8261.55 -4606 8261H-4608C-4608 8262.66 -4606.66 8264 -4605 8264V8262ZM2875 8261C2875 8261.55 2874.55 8262 2874 8262V8264C2875.66 8264 2877 8262.66 2877 8261H2875ZM2874 -2064C2874.55 -2064 2875 -2063.55 2875 -2063H2877C2877 -2064.66 2875.66 -2066 2874 -2066V-2064ZM-4605 -2066C-4606.66 -2066 -4608 -2064.66 -4608 -2063H-4606C-4606 -2063.55 -4605.55 -2064 -4605 -2064V-2066Z" fill="black" fill-opacity="0.1"/>
<path d="M-5136 -1639C-5136 -1640.1 -5135.1 -1641 -5134 -1641H2345C2346.1 -1641 2347 -1640.1 2347 -1639V8685C2347 8686.1 2346.1 8687 2345 8687H-5134C-5135.1 8687 -5136 8686.1 -5136 8685V-1639Z" fill=""/>
<g clip-path="url(#clip2_3388_33495)">
<rect width="428" height="5718" transform="translate(-187 -638)" fill=""/>
<g clip-path="url(#clip3_3388_33495)">
<path d="M0.666016 4.00016V14.6668L5.33268 12.0002L10.666 14.6668L15.3327 12.0002V1.3335L10.666 4.00016L5.33268 1.3335L0.666016 4.00016Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.33398 1.3335V12.0002" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.666 4V14.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<rect x="-15.5" y="-10" width="90" height="36" rx="18" stroke="#8E8E8E"/>
</g>
<path d="M-5134 -1640H2345V-1642H-5134V-1640ZM2346 -1639V8685H2348V-1639H2346ZM2345 8686H-5134V8688H2345V8686ZM-5135 8685V-1639H-5137V8685H-5135ZM-5134 8686C-5134.55 8686 -5135 8685.55 -5135 8685H-5137C-5137 8686.66 -5135.66 8688 -5134 8688V8686ZM2346 8685C2346 8685.55 2345.55 8686 2345 8686V8688C2346.66 8688 2348 8686.66 2348 8685H2346ZM2345 -1640C2345.55 -1640 2346 -1639.55 2346 -1639H2348C2348 -1640.66 2346.66 -1642 2345 -1642V-1640ZM-5134 -1642C-5135.66 -1642 -5137 -1640.66 -5137 -1639H-5135C-5135 -1639.55 -5134.55 -1640 -5134 -1640V-1642Z" fill="black" fill-opacity="0.1"/>
<defs>
<clipPath id="clip0_3388_33495">
<rect width="428" height="3145" fill="" transform="translate(-114 -1062)"/>
</clipPath>
<clipPath id="clip1_3388_33495">
<rect x="-84" y="-118" width="174" height="189" rx="20" fill=""/>
</clipPath>
<clipPath id="clip2_3388_33495">
<rect width="428" height="5718" fill="" transform="translate(-187 -638)"/>
</clipPath>
<clipPath id="clip3_3388_33495">
<rect width="16" height="16" fill=""/>
</clipPath>
</defs>
</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >

</style>